// extracted by css-extract-rspack-plugin
export default {"badge":"badge-cDxa8w","primary":"primary-bU68vw","error":"error-aOtiTd"};